
export class PreSelectCriteria {
  field:string;
  values:Array<any>;
}